import React from 'react';
import { connect } from 'react-redux';
import Checkbox from 'crehana-ui/Checkbox';
import Text from 'crehana-ui/Text';
import { toggleFilterLanguage } from '../../../redux/actions';

import { ItemWrapper } from '../styles';

type SubItem = {
  slug: string;
  id: number;
  name: string;
  disabled: boolean;
};

type Props = {
  languages: {
    id: string;
    name: string;
    subItems: {
      [key: string]: SubItem;
    };
  };
  selectedLanguages: string;
  toggleFilterLanguage(params: { subItemId: number }): void;
};

class Languages extends React.Component<Props> {
  onClickLanguage = ({ language }: { language: SubItem }) => () => {
    this.props.toggleFilterLanguage({ subItemId: language.id });
  };

  render() {
    const { languages, selectedLanguages } = this.props;
    const languagesArray = Object.keys(languages.subItems).map(
      level => languages.subItems[level],
    );

    return languagesArray.map(language => {
      const isSelected = !!selectedLanguages[language.id];

      return (
        <ItemWrapper
          key={language.id}
          style={{ opacity: language.disabled ? 0.3 : 1 }}
          onClick={language.disabled ? null : this.onClickLanguage({ language })}
        >
          <div className="flex items-center">
            <Text style={{ marginLeft: 8 }} type="body2">
              {language.name}
            </Text>
          </div>
          <Checkbox
            checked={isSelected}
            error={false}
            wrapperProps={{
              onClick: e => {
                e.preventDefault();
              },
            }}
          />
        </ItemWrapper>
      );
    });
  }
}

const mapStateToProps = state => ({
  languages: state.filters.languages,
  selectedLanguages: state.filters.selectedLanguages,
});

export default connect(
  mapStateToProps,
  { toggleFilterLanguage },
)(Languages);
